module.exports = __webpack_public_path__ + "img/ava2.637cba5c.svg";